export const financeConstants = { 

    FINANCE_SUMMARY_REQUEST: 'FINANCE_SUMMARY_REQUEST',
    FINANCE_SUMMARY_SUCCESS: 'FINANCE_SUMMARY_SUCCESS',
    FINANCE_SUMMARY_FAILURE: 'FINANCE_SUMMARY_FAILURE',

    GET_BILLS_REQUEST: 'GET_BILLS_REQUEST',
    GET_BILLS_SUCCESS: 'GET_BILLS_SUCCESS',
    GET_BILLS_FAILURE: 'GET_BILLS_FAILURE',

    ADD_BILLS_REQUEST: 'ADD_BILLS_REQUEST',
    ADD_BILLS_SUCCESS: 'ADD_BILLS_SUCCESS',
    ADD_BILLS_FAILURE: 'ADD_BILLS_FAILURE'

}